import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/badge-success.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-719864f4")

_pushScopeId("data-v-719864f4")
const _hoisted_1 = {
  id: "pickup-schedule-config-page",
  "data-testid": "pickup-schedule-config-page",
  style: {"display":"contents"}
}
const _hoisted_2 = { class: "w-full pr-4" }
const _hoisted_3 = { class: "flex flex-col items-center w-full text-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-20 h-20 flex items-center justify-center mb-4" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-full h-full",
    alt: "success"
  })
], -1)
const _hoisted_5 = { class: "text-base font-bold text-gray-lp-300 text-center mb-2" }
const _hoisted_6 = { class: "text-sm text-gray-lp-800 text-center leading-relaxed" }
const _hoisted_7 = { class: "flex flex-row justify-center w-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShipmentInfoSection = _resolveComponent("ShipmentInfoSection")!
  const _component_CardLayout = _resolveComponent("CardLayout")!
  const _component_SchedulePickupSection = _resolveComponent("SchedulePickupSection")!
  const _component_PickupAddressSidebarCard = _resolveComponent("PickupAddressSidebarCard")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_SavedAddressList = _resolveComponent("SavedAddressList")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      customClass: "px-0 overflow-y-auto",
      "header-padding": "pl-6",
      scrollSidebar: "",
      onBack: _ctx.onBack,
      title: _ctx.$t('pickup.scheduleConfig.pageTitle'),
      verticalSeparator: false,
      loading: _ctx.controller.isLoading,
      error: !!_ctx.controller.errorType,
      errorType: _ctx.controller.errorType,
      backButtonTestId: "pickup-schedule-config-button-back"
    }, {
      data: _withId(() => [
        _createVNode(_component_CardLayout, {
          loading: _ctx.controller.isLoading
        }, {
          default: _withId(() => [
            _createVNode(_component_ShipmentInfoSection, {
              estimateAdditionalKoli: _ctx.estimateAdditionalKoli,
              "onUpdate:estimateAdditionalKoli": _cache[1] || (_cache[1] = ($event: any) => (_ctx.estimateAdditionalKoli = $event)),
              estimateWeight: _ctx.estimateWeight,
              "onUpdate:estimateWeight": _cache[2] || (_cache[2] = ($event: any) => (_ctx.estimateWeight = $event)),
              serviceCodes: _ctx.serviceCodes,
              "onUpdate:serviceCodes": _cache[3] || (_cache[3] = ($event: any) => (_ctx.serviceCodes = $event)),
              clientName: _ctx.controller.config.clientName,
              additionalKoliError: _ctx.controller.estimateAdditionalKoliError,
              weightError: _ctx.controller.estimateWeightError,
              loading: _ctx.controller.isLoading
            }, null, 8, ["estimateAdditionalKoli", "estimateWeight", "serviceCodes", "clientName", "additionalKoliError", "weightError", "loading"])
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_CardLayout, {
          loading: _ctx.controller.isLoading
        }, {
          default: _withId(() => [
            _createVNode(_component_SchedulePickupSection, {
              enabled: _ctx.regularEnabled,
              "onUpdate:enabled": _cache[4] || (_cache[4] = ($event: any) => (_ctx.regularEnabled = $event)),
              days: _ctx.regularDays,
              "onUpdate:days": _cache[5] || (_cache[5] = ($event: any) => (_ctx.regularDays = $event)),
              specialEnabled: _ctx.specialEnabled,
              "onUpdate:specialEnabled": _cache[6] || (_cache[6] = ($event: any) => (_ctx.specialEnabled = $event)),
              specialDates: _ctx.specialDates,
              "onUpdate:specialDates": _cache[7] || (_cache[7] = ($event: any) => (_ctx.specialDates = $event)),
              loading: _ctx.controller.isLoading,
              slotStartHour: _ctx.controller.pickupDatePickerConfig.startHour,
              slotEndHour: _ctx.controller.pickupDatePickerConfig.endHour,
              slotIntervalMinutes: _ctx.slotIntervalMinutes
            }, null, 8, ["enabled", "days", "specialEnabled", "specialDates", "loading", "slotStartHour", "slotEndHour", "slotIntervalMinutes"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      "sub-data": _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_PickupAddressSidebarCard, {
            address: _ctx.selectedAddress,
            loading: _ctx.addressLoading,
            "can-submit": _ctx.canSubmit,
            "is-submitting": _ctx.isSubmitting,
            onChangeAddress: _ctx.onChangeAddress,
            onAddAddress: _ctx.onAddAddress,
            onSubmit: _ctx.onSaveSchedule
          }, null, 8, ["address", "loading", "can-submit", "is-submitting", "onChangeAddress", "onAddAddress", "onSubmit"])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType"]),
    _withDirectives(_createVNode(_component_SavedAddressList, {
      ref: "savedAddressListRef",
      "is-shown": _ctx.isSavedAddressListOpen,
      "client-id": _ctx.clientIdForAddress,
      "selected-address": _ctx.selectedAddress,
      "onUpdate:isShown": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isSavedAddressListOpen = $event)),
      onSelectAddress: _ctx.onSelectAddress,
      onUpdateDefaultAddress: _ctx.onAddressListRefresh,
      onAddressDeleted: _ctx.onAddressListRefresh
    }, null, 8, ["is-shown", "client-id", "selected-address", "onSelectAddress", "onUpdateDefaultAddress", "onAddressDeleted"]), [
      [_vShow, _ctx.isSavedAddressListOpen]
    ]),
    (_ctx.showModalSuccess)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          width: "w-[500px]",
          onClose: _ctx.onCloseSuccessModal,
          showBorderTitle: false,
          titlePadding: 'p-0',
          contentPadding: 'px-8 pt-6 pb-2',
          footerPadding: 'px-8 pt-2 pb-6',
          marginHeader: 'mb-0',
          marginFooter: 'mt-0',
          isShadows: false,
          footerBgColor: "bg-white",
          borderTop: "border-t-0"
        }, {
          content: _withId(() => [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.isMalaysia
                ? "Pick Up Schedule saved successfully"
                : "Jadwal Pick Up berhasil disimpan"), 1),
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.isMalaysia
                ? "Configuration has been saved & will be applied starting tomorrow."
                : "Konfigurasi telah tersimpan & akan diterapkan dimulai besok."), 1)
            ])
          ]),
          footer: _withId(() => [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_LpButton, {
                "is-width-full": "",
                title: _ctx.isMalaysia ? 'Close' : 'Tutup',
                outline: "",
                color: "gray-lp-1600",
                "text-color": "black-lp-100",
                class: "py-3",
                onClick: _ctx.onCloseSuccessModal
              }, null, 8, ["title", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('pickup.scheduleConfig.leaveModal.title'),
      message: _ctx.$t('pickup.scheduleConfig.leaveModal.description'),
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('pickup.scheduleConfig.leaveModal.buttonConfirm'),
      textCancel: _ctx.$t('pickup.scheduleConfig.leaveModal.buttonCancel'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ])
  ]))
})